'use strict';

var Player = require('./player');
var PlayerShot = require('./playershot');
var Powerup = require('./powerup');
var Enemy = require('./enemy');

module.exports = {
    Player: Player,
    PlayerShot: PlayerShot,
    Powerup: Powerup,
    Enemy: Enemy
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/gradience/ecs/entities/index.js
 ** module id = 14
 ** module chunks = 0
 **/